import { AxiosResponse } from "axios";
import qs from "query-string";
import { eventVersionService } from "src/services/eventVersionService/eventVersionService";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ListResponse, PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

import { EventReport } from "../../dashboard/devices/types";

export type Category =
    "build" | "device" | "file" | "gateway" | "group" | "license" | "product" | "provisioning" | "user" | "workspace";

export type FetchAllEventsPayload = {
    pageIndex?: number;
    pageSize?: number;
    levels?: number[];
    workspaceIds?: number[];
    groupIds?: number[];
    entityIds?: string[];
    categories?: Category[];
    createdFrom?: string;
    createdTo?: string;
    searchTerm?: string;
    sortCriteria?: string;
    sortDirection?: "ascending" | "descending";
};

export async function fetchAllEvents(params: FetchAllEventsPayload = {}): Promise<ListResponse<EventReport>> {
    try {
        const endpoint = await RouteService.getAdminEventsRoute();
        const response: AxiosResponse<PaginatedResponse<API.EventReport>> = await HttpService.get(endpoint + "events/all", {
            params,
            paramsSerializer: () => qs.stringify(params, { arrayFormat: "index" }),
        });
        return {
            ...response.data,
            list: eventVersionService.normalizeList(response.data.list),
        };
    } catch (error) {
        throw unpackError(error);
    }
}
